import NotificationsWrapper from '@datacloud-incubation/frontend-notifications-module';
import { FloatingPortal } from '@floating-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PORTAL } from '@core/constants/portal.constant';
import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import WrapperAbcloudzFlowChat from 'AbcloudzFlowChat/WrapperAbcloudzFlowChat';
import './index.css';

const App = () => {
  return (
    <>
      <FloatingPortal root={PORTAL.root} id={PORTAL.modal}>
        <NotificationsWrapper />
      </FloatingPortal>
      <QueryClientProvider client={tanstackQueryService.queryClient}>
        <WrapperAbcloudzFlowChat />
        <ReactQueryDevtools buttonPosition='top-right' />
      </QueryClientProvider>
    </>
  );
};

export default App;
